import React, { useEffect } from 'react'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import Login from '../components/Login'
import { useUser } from 'providers'
import { AkaTypography } from 'components'
import { ROUTES } from '../../navigation'
import { StyledContent, StyledLink } from '../components/styles'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const validationSchema = t =>
	Yup.object().shape({
		email: Yup.string()
			.email(t('auth.validations.email'))
			.required(t('auth.emailRequired')),
		password: Yup.string().required(t('auth.passwordRequired'))
	})

const LoginPage = () => {
	const [t] = useTranslation()
	const {
		user,
		login,
		error,
		loadingAuth: loading,
		loadingVerify,
		isAuthenticated,
		redirect
	} = useUser()

	useEffect(() => {
		if (user && isAuthenticated && !loadingVerify && !loading) {
			redirect(ROUTES.home)
		}
	}, [user, redirect, loadingVerify, loading, isAuthenticated])

	const handleSubmit = variables => {
		login(variables)
	}

	if (user && isAuthenticated && !loadingVerify && !loading)
		return (
			<AkaTypography variant="bodySegoe2">
				You are already logged in
			</AkaTypography>
		)

	return (
		<PublicLayout>
			<StyledContent>
				<Login
					validationSchema={validationSchema(t)}
					onSubmit={handleSubmit}
					loading={loading}
					error={error}
				/>
				<StyledLink to={ROUTES.registration}>
					<AkaTypography variant={'bodySegoe'} color={'primary'}>
						{t('auth.requestAccount')}
					</AkaTypography>
				</StyledLink>
				<StyledLink to={ROUTES.passwordReset}>
					<AkaTypography
						gutterbottom={0}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.passwordForget')}
					</AkaTypography>
				</StyledLink>
			</StyledContent>
		</PublicLayout>
	)
}

export default LoginPage
